import { render, staticRenderFns } from "./CompetitionDetailDefaultLayout.vue?vue&type=template&id=931649ea&scoped=true"
import script from "./CompetitionDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931649ea",
  null
  
)

export default component.exports